<template>
 <div class="ml-auto">
   <van-col v-if="rateObj.rating<1"  class="ml-auto font-10 text-primary"
            @click="showRate=true">
     <div class="rate-show cursor-pointer">评价</div>
   </van-col>
   <van-col v-else class="ml-auto font-10 color-88">
     已评分：{{rateObj.rating}}分
   </van-col>
   <!--星级评分弹框-->
   <van-overlay class="rate" :show="showRate">
     <div class="rate-block position-relative">
       <van-icon name="cross" class="position-absolute close-tn cursor-pointer" @click="showRate=false"/>
       <p class="mb-1 font-18 text-center">请用星级对这个小节进行评价</p>
       <p class="mb-2 font-10 color-88 text-center">您的反馈将有助于内容持续改善</p>
       <van-rate class="d-flex justify-content-center pb-3"
                 v-model="rateObj.rating"
                 :size="35"
                 color="#ffd21e"
                 void-icon="star"
                 void-color="#eee"
       />
       <van-field class="border rounded-lg mt-3 mb-3"
                  v-model="rateObj.content"
                  rows="2"
                  autosize
                  type="textarea"
                  maxlength="200"
                  placeholder="请提一点建议吧"
                  show-word-limit
       />

       <p class="mb-0 font-10 d-flex align-items-center">
         <van-image class="avatar mr-1" round :src="curUser.avatarUrl|getAvator"/>
         <span class="color-88">{{curUser.name}}</span>
       </p>
       <div class="m-3" @click="submitRate">
         <van-button round block type="info" native-type="submit">提交</van-button>
       </div>
     </div>

   </van-overlay>
 </div>
</template>

<script>
  import Vue from 'vue';
  import {
    Icon,
    Button,
    Col,
    Row,
    Field,
    Overlay,
    Rate,
    Image as VanImage, Toast
  } from 'vant';

  Vue.use(VanImage);
  Vue.use(Field);
  Vue.use(Overlay);
  Vue.use(Rate);
  Vue.use(Col);
  Vue.use(Row);
  Vue.use(Button);
  Vue.use(Icon);

  import Cookies from "js-cookie";
    export default {
      name: "rateComponent",
      data(){
          return {
            rateObj: {rating:0, content:''},
            curUser: '',
            tid: '',
            mainType: '',
            showRate: false,
          }
      },
      props: [
        'mainId',
        'type',
      ],
      created() {
        this.tid = this.mainId;
        this.mainType = this.type;
      },
      mounted() {
        this.curUser = JSON.parse(Cookies.get('u_info'));
        this.getRate();
      },
      methods: {
        //提交评价
        submitRate() {
          this.rateObj.mainId = this.tid;
          this.rateObj.mainType = this.mainType;
          if(this.rateObj.rating < 1) {
            this.$toast('请为小节打分！');
            return;
          }
          this.$store.dispatch('addReview',{model: this.rateObj}).then((res) => {
            this.$toast('评价成功！');
            this.showRate = false;
          }).catch(err => {
            if (err && err.response.data.consumerMessage) {
              this.$toast(err.response.data.consumerMessage);
            } else {
              this.$toast('评价失败');
            }
          });
        },
        //获取评价
        getRate() {
          this.$store.dispatch('getReview', {mainType: this.mainType, mainId: this.tid}).then((res) => {
            this.rateObj.rating = res.rating;
          }).catch(err=>{
            if (err.response.status === 404) {
              setTimeout(()=>{
                this.$toast.clear()
              },0)

            }
          })
        },
      }
    }
</script>

<style scoped lang="scss">
  $browser-default-font-size: 16px !default;
  @function pxTorem($px) {
    @return $px / $browser-default-font-size * 1rem;
  }

  .rate-show {
    border: 1px solid #2474ff;
    padding: pxTorem(2px) pxTorem(10px) pxTorem(2px) pxTorem(10px);
    border-radius: pxTorem(4px);
  }

  .rate {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    z-index: 9999!important;
  }

  .rate-block {
    width: pxTorem(300px);
    background-color: #fff;
    padding: pxTorem(32px) pxTorem(16px) pxTorem(16px) pxTorem(16px);
    .avatar {
      width: pxTorem(24px);
      height: pxTorem(24px);
    }
    .close-tn {
      right: pxTorem(8px);
      top: pxTorem(8px);
      color: #666666;
    }
  }

  .u-avatar {
    width: pxTorem(20px);
    height: pxTorem(20px);
    border-radius: 50%;
  }


</style>
